import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, HelpCircle } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { FAQ } from "@/components/FAQ";

export default function Faqs() {
  return (
    <div className="min-h-screen text-foreground">
      <Navbar />
      <div className="mx-auto max-w-4xl px-4 sm:px-8 py-14 lg:py-20">
        <p className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.25em] text-primary"><HelpCircle size={14} /> Frequently asked questions</p>
        <h1 className="mt-3 font-serif text-4xl font-extrabold tracking-tight sm:text-5xl">Everything you need to know</h1>
        <p className="mt-4 max-w-2xl text-lg text-muted-foreground">Still unsure about something? These cover the questions I'm asked most.</p>
        <div className="mt-8 grid grid-cols-2 gap-4" data-testid="faqs-images">
          <img src="/media/jt-playing-6.webp" alt="Jason Thompson playing a Hammond organ on an open-air stage" className="h-56 w-full rounded-3xl border border-border object-cover sm:h-72" data-testid="faqs-image-organ" />
          <img src="/media/jt-playing-5.jpg" alt="Jason Thompson performing, black and white" className="h-56 w-full rounded-3xl border border-border object-cover sm:h-72" data-testid="faqs-image-bw" />
        </div>
        <div className="mt-10"><FAQ /></div>
        <div className="mt-12 flex flex-col items-start justify-between gap-4 rounded-3xl border border-border bg-card p-8 sm:flex-row sm:items-center">
          <p className="font-serif text-xl font-bold sm:text-2xl">Still have a question?</p>
          <Link to="/about#booking" data-testid="faqs-contact-cta"><Button className="rounded-full bg-primary px-6 py-6 text-primary-foreground hover:bg-primary/90">Get in touch <ArrowRight size={16} className="ml-2" /></Button></Link>
        </div>
      </div>
    </div>
  );
}
